/**
 * Actieve filters notice.
 */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { queryParams } from "../store/queryParams";
import filterParams from "../actions/filterParams";
import setSearchUrl from "../actions/setSearchUrl";
import { setQueryValue } from "../reducers";
class ActiveFilters extends Component {
	render(props) {
		const {
			activeCategoriesObj,
			activeLocation,
			activeQuery,
			activeRegions,
			activeSubjects
		} = this.props.state;

		const resetQuery = (e) => {
			this.props.dispatch(setQueryValue(e.currentTarget.value));
			this.props.dispatch(
				setSearchUrl({
					[queryParams.query]: "",
					[queryParams.page]: "",
				})
			);
			document.querySelector(".queryValue").value = "";
		};

		const resetCategory = (e) => {
			let categoryQuery = e.currentTarget.dataset.category;

			if (categoryQuery.includes("|")) {
				let categories = categoryQuery.split("|");
				this.props.dispatch(
					setSearchUrl({
						[queryParams.topTheme]: categories[0],
						[queryParams.theme]: "",
						[queryParams.page]: "",
					})
				);
			} else {
				this.props.dispatch(
					setSearchUrl({
						[queryParams.topTheme]: "",
						[queryParams.theme]: "",
						[queryParams.page]: "",
					})
				);
			}
		};

		const resetRegion = (e) => {
			let regions = filterParams(
				"regions",
				e.currentTarget.dataset.region
			);
			if ("undefined" !== typeof regions) {
				this.props.dispatch(
					setSearchUrl({
						[queryParams.regions]: regions,
						[queryParams.page]: "",
					})
				);
			} else {
				this.props.dispatch(
					setSearchUrl({
						[queryParams.regions]: "",
						[queryParams.page]: "",
					})
				);
			}
		};

		const getSubjectLabel = (slug) => {
			const subject = this.props.state.subjects.filter(obj => obj.slug === slug && obj.label)
			if (subject.length > 0) {
				return subject[0].label.replaceAll('&amp;', '&')
			}
		}

		const resetSubject = (e) => {
			let subjects = filterParams(
				"vakken",
				e.currentTarget.dataset.subject
			);
			if ("undefined" !== typeof subjects) {
				this.props.dispatch(
					setSearchUrl({
						[queryParams.subjects]: subjects,
						[queryParams.page]: "",
					})
				);
			} else {
				this.props.dispatch(
					setSearchUrl({
						[queryParams.subjects]: "",
						[queryParams.page]: "",
					})
				);
			}
		};

		const resetLocation = (e) => {
			this.props.dispatch(
				setSearchUrl({
					[queryParams.vicinityCity]: "",
					[queryParams.vicinityCoords]: "",
					[queryParams.page]: "",
				})
			);
			document.querySelector(".locationValue").value = "";
		};

		return (
			<Fragment>
				{("undefined" !== typeof activeCategoriesObj.activeCategory ||
					"" !== activeQuery ||
					activeRegions.length > 0 ||
					"undefined" !== typeof activeLocation.city ||
					activeSubjects.length > 0) && (
					<div className="filtered-results__selection has-pastel-lk-blue-background-color has-xs-top-margin">
						<p>Je zocht op:</p>
						<ul className="filtered-results__filters filters">
							{activeQuery && (
								<li className="filtered-results__filter filter">
									<div className="filter__main">
										{activeQuery}
										<button
											className="filter__close"
											onClick={resetQuery}
										>
											<span className="visually-hidden">
												Verwijder
											</span>
											<span className="icon icon--x icon-size--s"></span>
										</button>
									</div>
								</li>
							)}
							{activeCategoriesObj.activeCategoryLabel && (
								<li className="filtered-results__filter filter">
									<div
										className={
											"filter__main" +
											(activeCategoriesObj.activeSubcategoryLabel
												? " is-parent"
												: "")
										}
									>
										{
											activeCategoriesObj.activeCategoryLabel
										}
										<button
											className="filter__close"
											data-category={
												activeCategoriesObj.activeCategory
											}
											onClick={(e) => {
												resetCategory(e);
											}}
										>
											<span className="visually-hidden">
												Verwijder
											</span>
											<span className="icon icon--x icon-size--s"></span>
										</button>
									</div>
									{activeCategoriesObj.activeSubcategoryLabel && (
										<ul className="filter__children">
											<li className="filter__child">
												<div
													className={
														"filter__main is-child"
													}
												>
													{
														activeCategoriesObj.activeSubcategoryLabel
													}
													<button
														className="filter__close"
														data-category={
															activeCategoriesObj.activeCategory +
															"|" +
															activeCategoriesObj.activeSubcategory
														}
														onClick={(e) => {
															resetCategory(e);
														}}
													>
														<span className="visually-hidden">
															Verwijder
														</span>
														<span className="icon icon--x icon-size--s"></span>
													</button>
												</div>
											</li>
										</ul>
									)}
								</li>
							)}
							{"undefined" !== typeof activeLocation.city && (
								<li className="filtered-results__filter filter">
									<div className="filter__main">
										{activeLocation.city}
										<button
											className="filter__close"
											onClick={(e) => {
												resetLocation(e);
											}}
										>
											<span className="visually-hidden">
												Verwijder
											</span>
											<span className="icon icon--x icon-size--s"></span>
										</button>
									</div>
								</li>
							)}
							{activeRegions &&
								activeRegions.length > 0 &&
								activeRegions.map((region, index) => (
									<li className="filtered-results__filter filter">
										<div className="filter__main">
											{region}
											<button
												className="filter__close"
												data-region={region}
												onClick={(e) => {
													resetRegion(e);
												}}
											>
												<span className="visually-hidden">
													Verwijder
												</span>
												<span className="icon icon--x icon-size--s"></span>
											</button>
										</div>
									</li>
								))}
							{activeSubjects &&
								activeSubjects.length > 0 &&
								activeSubjects.map((subject) => (
									<li className="filtered-results__filter filter">
										<div className="filter__main">
											{getSubjectLabel(subject)}
											<button
												className="filter__close"
												data-subject={subject}
												onClick={(e) => {
													resetSubject(e);
												}}
											>
												<span className="visually-hidden">
													Verwijder
												</span>
												<span className="icon icon--x icon-size--s"></span>
											</button>
										</div>
									</li>
								))
							}
						</ul>
					</div>
				)}
			</Fragment>
		);
	}
}

function mapStateToProps(state) {
	return { state };
}

export default connect(mapStateToProps)(ActiveFilters);
